import React from "react";

const Img = ({
  className,
  src = process.env.PUBLIC_URL + "/images/404-image.png",
  alt = "testImg",
  ...restProps
}) => {
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      {...restProps}
      loading={"lazy"}
    />
  );
};
export { Img };
